import React from 'react'
import { Icon } from '@iconify/react'
import { Button } from '../../../../components/ui/legacy'

const FormHeader = ({ title, handleCancel, onAccept, actionName, disableSubmit }) => (
  <section>
    <header>
      <div className="flex justify-between items-center">
        <h1 className="pr-8 text-4xl font-bold text-black truncate">{title}</h1>
        <div className="flex space-x-4">
          <Button
            type="button"
            variant="tertiary"
            onClickHandler={handleCancel}
            className="px-2 py-2"
          >
            Hủy
          </Button>
          <Button
            onClick={onAccept}
            variant="primary"
            type="button"
          >
            {actionName}
          </Button>
        </div>
      </div>
    </header>

  </section>
)

export default FormHeader
